export const FailureReasons = {
    alreadyAccepted: 'already_accepted',
    alreadyRejected: 'already_rejected',
    forbidden: 'forbidden',
    unknown: 'unknown',
} as const;
export type FailureReason = (typeof FailureReasons)[keyof typeof FailureReasons];
